import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from '@/routing/helpers/router';
import axios from 'axios';
import Moment from 'moment';

export const handleMinDate = (moduleData) => {
  if (!moduleData?.isMinDate) return new Date(2021, 0, 1);
  const today = Moment();
  const firstOfMarch = Moment({ year: today.year(), month: 2, day: 1 });

  return today.isSameOrAfter(firstOfMarch)
    ? new Date(today.year(), 0, 1)
    : new Date(today.year() - 1, 0, 1);
};

export const handleDisabled = (moduleData, year) => {
  if (!moduleData?.isMinDate) return false;

  const today = Moment();
  const inputYear = Number(year);
  const currentYear = today.year();

  if (currentYear > inputYear) {
    return currentYear !== inputYear + 1 || today.month() >= 2;
  }

  return false;
};

export const getFile = (moduleBridgeHex, subModuleBridgeHex, plantHex, reportType, typeId, salt, dispatch) => axios
      .post(
          axiosPath('api_r_user_module_comsaReports_getFile'),
          {
            moduleBridgeHex,
            subModuleBridgeHex,
            plantHex,
            reportType,
            typeId,
            salt,
          }
      )
      .then(({ data }) => (window.location = data))
      .catch((e) => dispatch(errorHandler(e)))